module.exports = __webpack_public_path__ + "static/media/marker-gray.3007e4d5.png";